module.exports = __webpack_public_path__ + "img/dani2.1c037f17.png";